<template>
  <header class="app-header" :class="[{ 'is-hovering': headerHovering }, isUserPage ? 'header-bg-user' : 'bg-white']"
    :style="headerFxStyle" @mousemove="onHeaderMouseMove" @mouseleave="onHeaderMouseLeave">
    <div class="header-fx" aria-hidden="true">
      <span class="header-fx__spot" />
      <span class="header-fx__shine" />
      <span class="header-fx__line" />
    </div>
    <div class="header-inner flex align-center justify-between">
      <div class="logo flex align-center flex-shrink-0">
        <img src="@/assets/icon64.png" class="w-260 h-65" alt="">
        <!-- <span class="logo-text text-bold text-green text-20 margin-left-10">东软天枢院</span> -->
      </div>
      <div class="nav-wrap flex align-center">
        <nav class="nav-menu flex align-center">
          <router-link v-for="item in navList" :key="item.path" :to="item.path" class="nav-item"
            :class="{ active: isActive(item.path) }">
            {{ item.name }}
          </router-link>
        </nav>
      </div>
      <div class="header-right flex align-center flex-shrink-0">
        <a href="tel:400-886-8338" class="header-phone text-20 text-bold margin-right-16">400-886-8338</a>
        <button type="button" class="search-icon-btn margin-right-16" title="搜索" @click="goSearch">
          <i class="el-icon-search" />
        </button>
        <template v-if="loggedIn">
          <!-- <el-button v-if="isEngineerRole" type="success" size="small" class="publish-btn margin-right-16"
            @click="goPublish">
            + 发布需求
          </el-button> -->
          <div class="user-trigger flex align-center margin-right-20" @click="goUserCenter">
            <img :src="user.avatar_url || defaultAvatar" class="icon-36 margin-right-12 user-avatar" alt="">
            <span class="user-name text-16">{{ user.nickname || user.mobile }}</span>
          </div>
          <el-button type="success" size="small" class="logout-btn" @click="logoutVisible = true">退出</el-button>
        </template>
        <template v-else>
          <img src="@/assets/icon13.png" class="icon-36 margin-right-20 margin-left-30" />
          <el-button type="success" size="small" class="login-btn" @click="loginVisible = true">登录</el-button>
        </template>
      </div>
    </div>

    <el-dialog :visible.sync="logoutVisible" width="32.5rem" custom-class="logout-dialog" :show-close="false"
      append-to-body>
      <div class="logout-modal">
        <div class="logout-header flex align-center">
          <div class="logout-icon-wrap flex align-center justify-center">
            <img src="@/assets/icon23.png" class="icon-40" alt="">
          </div>
          <span class="logout-title text-20">提醒</span>
        </div>
        <div class="logout-message">您确认要退出登录吗？</div>
        <div class="logout-actions flex justify-end">
          <button type="button" class="logout-btn-cancel text-14" @click="logoutVisible = false">取消</button>
          <button type="button" class="logout-btn-confirm text-14" @click="confirmLogout">确认</button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="loginVisible" width="28.75rem" custom-class="login-dialog" :show-close="false"
      append-to-body>
      <div class="login-modal">
        <div class="login-header flex flex-direction align-center">
          <img src="@/assets/icon65.png" class="icon-96" />
          <div class="login-title text-24 margin-top-12">东软天枢院</div>
        </div>

        <el-form ref="loginFormRef" :model="loginForm" :rules="loginRules" class="login-form margin-top-28"
          @submit.native.prevent="handleLogin">
          <el-form-item prop="phone">
            <span slot="label" class="login-label flex align-center text-14">
              <img src="@/assets/icon14.png" class="login-label-icon" alt="">
              手机号
            </span>
            <el-input v-model="loginForm.phone" placeholder="请输入手机号" class="login-input" />
          </el-form-item>

          <el-form-item prop="code">
            <span slot="label" class="login-label flex align-center text-14">
              <img src="@/assets/icon22.png" class="login-label-icon" alt="">
              验证码
            </span>
            <div class="code-field">
              <input v-model="loginForm.code" type="text" class="code-field__input text-14" placeholder="请输入验证码">
              <div class="code-field__action" :class="{ 'is-disabled': codeCountdown > 0 }">
                <button type="button" class="code-field__btn text-14" :disabled="codeCountdown > 0"
                  @click="handleGetCode">
                  {{ codeBtnText }}
                </button>
              </div>
            </div>
          </el-form-item>
        </el-form>

        <button type="button" class="login-submit-btn text-16" @click="handleLogin">登录</button>

        <div class="login-agreement flex align-center justify-center margin-top-24">
          <el-checkbox v-model="agreedToTerms" class="login-checkbox">
            <span class="agreement-text text-14">
              已阅读并同意
              <a href="#" class="agreement-link" @click.stop.prevent="goAgreement('agreement')">《用户协议》</a>
              和
              <a href="#" class="agreement-link" @click.stop.prevent="goAgreement('privacy')">《隐私政策》</a>
            </span>
          </el-checkbox>
        </div>
      </div>
    </el-dialog>
  </header>
</template>

<script>
import eventBus from '@/utils/eventBus'
import { bindFlexibleRem, unbindFlexibleRem } from '@/utils/flexibleRem'
import { sendSms } from '@/api/sms'
import { mobileLogin, fetchUserInfo } from '@/api/user'
import { saveUserInfo, getUserInfo, clearUserInfo } from '@/utils/auth'

const DEFAULT_AVATAR = require('@/assets/icon13.png')

export default {
  name: 'AppHeader',
  data() {
    return {
      loggedIn: false,
      defaultAvatar: DEFAULT_AVATAR,
      user: {},
      logoutVisible: false,
      loginVisible: false,
      agreedToTerms: false,
      codeCountdown: 0,
      codeTimer: null,
      headerHovering: false,
      headerSpotX: 50,
      headerSpotY: 50,
      headerTiltX: 0,
      headerTiltY: 0,
      headerRaf: 0,
      loginForm: {
        phone: '',
        code: ''
      },
      loginRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      navList: [
        { name: '首页', path: '/' },
        { name: '技术服务', path: '/service' },
        { name: '服务案例', path: '/cases' },
        { name: '技术工程师', path: '/engineer' },
        { name: '课程服务', path: '/course' },
        { name: '配套资源', path: '/resource' }
      ]
    }
  },
  computed: {
    isEngineerRole() {
      return this.user.identity_type === 'engineer'
    },
    isUserPage() {
      const path = this.$route.path
      if (
        path.startsWith('/user')
        || path.startsWith('/engineer-center')
        || path === '/identity'
        || path === '/profile-setup'
        || path === '/engineer-home'
        || path.startsWith('/engineer/demands')
        || /^\/engineer\/\d+$/.test(path)
      ) {
        return true
      }
      return this.loggedIn && this.isEngineerRole
    },
    codeBtnText() {
      return this.codeCountdown > 0 ? `${this.codeCountdown}s` : '获取'
    },
    headerFxStyle() {
      return {
        '--spot-x': `${this.headerSpotX}%`,
        '--spot-y': `${this.headerSpotY}%`,
        '--tilt-x': `${this.headerTiltX}deg`,
        '--tilt-y': `${this.headerTiltY}deg`
      }
    }
  },
  created() {
    this.syncAuthState(true)
    eventBus.$on('auth:unauthorized', this.handleUnauthorized)
    eventBus.$on('auth:changed', this.handleAuthChanged)
  },
  mounted() {
    bindFlexibleRem()
  },
  watch: {
    '$route'() {
      this.syncAuthState(false)
    }
  },
  beforeDestroy() {
    eventBus.$off('auth:unauthorized', this.handleUnauthorized)
    eventBus.$off('auth:changed', this.handleAuthChanged)
    this.clearCodeTimer()
    if (this.headerRaf) cancelAnimationFrame(this.headerRaf)
    unbindFlexibleRem()
  },
  methods: {
    onHeaderMouseMove(e) {
      const el = e.currentTarget
      if (!el) return
      const rect = el.getBoundingClientRect()
      const x = e.clientX - rect.left
      const y = e.clientY - rect.top
      const px = x / rect.width
      const py = y / rect.height
      if (this.headerRaf) cancelAnimationFrame(this.headerRaf)
      this.headerRaf = requestAnimationFrame(() => {
        this.headerHovering = true
        this.headerSpotX = px * 100
        this.headerSpotY = py * 100
        this.headerTiltY = (px - 0.5) * 1.6
        this.headerTiltX = (0.5 - py) * 1.2
      })
    },
    onHeaderMouseLeave() {
      if (this.headerRaf) cancelAnimationFrame(this.headerRaf)
      this.headerHovering = false
      this.headerSpotX = 50
      this.headerSpotY = 50
      this.headerTiltX = 0
      this.headerTiltY = 0
    },
    isActive(path) {
      if (path === '/') return this.$route.path === '/'
      return this.$route.path.startsWith(path)
    },
    goUserCenter() {
      if (!this.loggedIn) {
        this.loginVisible = true
        return
      }
      this.$router.push('/user/projects')
    },
    goPublish() {
      this.$router.push('/publish')
    },
    goSearch() {
      this.$router.push({ path: '/search' })
    },
    handleAuthChanged() {
      this.syncAuthState(true)
    },
    syncAuthState(refresh = false) {
      this.loggedIn = sessionStorage.getItem('isLoggedIn') === '1' && !!sessionStorage.getItem('token')
      if (!this.loggedIn) {
        this.user = {}
        return
      }
      const cached = getUserInfo()
      if (cached) {
        this.user = { ...cached }
      }
      if (refresh) {
        this.loadUserInfo()
      }
    },
    loadUserInfo() {
      fetchUserInfo()
        .then((res) => {
          const data = res.data || {}
          this.user = { ...this.user, ...data }
          const cached = getUserInfo() || {}
          sessionStorage.setItem('userInfo', JSON.stringify({ ...cached, ...data }))
        })
        .catch(() => { })
    },
    handleGetCode() {
      if (this.codeCountdown > 0) return
      this.$refs.loginFormRef.validateField('phone', (errorMessage) => {
        if (errorMessage) return
        sendSms({
          mobile: this.loginForm.phone.trim(),
          event: 'mobilelogin'
        }).then((res) => {
          this.$message.success(res.msg || '验证码已发送')
          this.startCodeCountdown()
        })
      })
    },
    startCodeCountdown() {
      this.codeCountdown = 60
      this.codeTimer = setInterval(() => {
        this.codeCountdown -= 1
        if (this.codeCountdown <= 0) this.clearCodeTimer()
      }, 1000)
    },
    clearCodeTimer() {
      if (this.codeTimer) {
        clearInterval(this.codeTimer)
        this.codeTimer = null
      }
      this.codeCountdown = 0
    },
    handleLogin() {
      if (!this.agreedToTerms) {
        this.$message.warning('请先阅读并同意用户协议和隐私政策')
        return
      }
      this.$refs.loginFormRef.validate((valid) => {
        if (!valid) return
        mobileLogin({
          mobile: this.loginForm.phone.trim(),
          captcha: this.loginForm.code.trim()
        }).then((res) => {
          this.agreedToTerms = false;
          const userinfo = res.data.userinfo
          saveUserInfo(userinfo)
          this.syncAuthState(true)
          this.loginVisible = false
          this.clearCodeTimer()
          this.loginForm.phone = ''
          this.loginForm.code = ''
          this.$message.success(res.msg || '登录成功')
          const path = this.$route.path
          const onUserOnlyPage = path.startsWith('/user')
            || path.startsWith('/engineer-center')
            || path === '/identity'
            || path === '/profile-setup'
            || path === '/engineer-home'
            || path.startsWith('/engineer/demands')
          if (onUserOnlyPage) {
            this.$router.push('/')
          }
          // if (userinfo.activation_status === 1) {
          //   this.$router.push('/identity')
          // } else {
          //   this.$router.push('/')
          // }
        })
      })
    },
    goAgreement(type) {
      this.loginVisible = false
      this.$router.push(`/user/settings/${type}`)
    },
    handleUnauthorized() {
      if (this.loginVisible) return
      clearUserInfo()
      sessionStorage.removeItem('userRole')
      this.syncAuthState(false)
      this.logoutVisible = false
      this.loginVisible = true
    },
    confirmLogout() {
      this.logoutVisible = false
      clearUserInfo()
      sessionStorage.removeItem('userRole')
      this.syncAuthState(false)
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.app-header {
  --spot-x: 50%;
  --spot-y: 50%;
  --tilt-x: 0deg;
  --tilt-y: 0deg;
  flex-shrink: 0;
  height: 4.375rem;
  z-index: 100;
  border-bottom: 0.0625rem solid rgba(209, 217, 213, 0.6);
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  transition:
    border-color 0.35s ease,
    box-shadow 0.35s ease;

  &.header-bg-user {
    background: linear-gradient(135deg, #f0faf4 0%, #e8f5ed 50%, #f0faf4 100%);
    background-size: 200% 200%;
    animation: gradientShift 8s ease infinite;
  }

  &:not(.header-bg-user) {
    background: linear-gradient(135deg, #ffffff 0%, #fafcfb 50%, #ffffff 100%);
    background-size: 200% 200%;
    animation: gradientShift 10s ease infinite;
  }

  &.is-hovering {
    border-bottom-color: rgba(0, 157, 66, 0.35);
    box-shadow:
      0 0.5rem 1.75rem rgba(0, 157, 66, 0.1),
      0 0.125rem 0.5rem rgba(15, 23, 42, 0.04);

    .header-fx__spot,
    .header-fx__shine,
    .header-fx__line {
      opacity: 1;
    }

    .header-inner {
      transform: perspective(60rem) rotateX(var(--tilt-x)) rotateY(var(--tilt-y));
    }
  }
}

.header-fx {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
}

.header-fx__spot {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 0.35s ease;
  background: radial-gradient(28rem circle at var(--spot-x) var(--spot-y),
      rgba(0, 157, 66, 0.16) 0%,
      rgba(57, 181, 74, 0.08) 28%,
      rgba(57, 181, 74, 0.02) 48%,
      transparent 68%);
}

.header-fx__shine {
  position: absolute;
  top: -40%;
  left: calc(var(--spot-x) - 18%);
  width: 36%;
  height: 180%;
  opacity: 0;
  transition: opacity 0.35s ease, left 0.12s linear;
  background: linear-gradient(105deg,
      transparent 0%,
      rgba(255, 255, 255, 0.55) 45%,
      rgba(255, 255, 255, 0.12) 55%,
      transparent 100%);
  transform: skewX(-18deg);
  mix-blend-mode: soft-light;
}

.header-fx__line {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0.125rem;
  opacity: 0;
  transition: opacity 0.35s ease;
  background: linear-gradient(90deg,
      transparent 0%,
      rgba(0, 157, 66, 0.15) calc(var(--spot-x) - 18%),
      rgba(0, 157, 66, 0.85) var(--spot-x),
      rgba(0, 157, 66, 0.15) calc(var(--spot-x) + 18%),
      transparent 100%);
  box-shadow: 0 0 0.75rem rgba(0, 157, 66, 0.35);
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.header-inner {
  position: relative;
  z-index: 1;
  height: 4.375rem;
  box-sizing: border-box;
  max-width: 100%;
  padding: 0 clamp(1rem, 8vw, 6.25rem);
  overflow: hidden;
  transform-origin: center center;
  transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);
  will-change: transform;
}

@media (prefers-reduced-motion: reduce) {

  .app-header,
  .header-inner,
  .header-fx__spot,
  .header-fx__shine,
  .header-fx__line {
    transition: none !important;
    animation: none !important;
  }

  .app-header.is-hovering .header-inner {
    transform: none !important;
  }
}

.logo,
.header-right {
  flex-shrink: 0;
}

.logo-text {
  white-space: nowrap;
  transition: all 0.3s ease;
}

.logo {
  cursor: pointer;
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);

  &:hover {
    transform: scale(1.02);

    .logo-text {
      text-shadow: 0 0 1.25rem rgba(57, 181, 74, 0.3);
    }
  }
}

.nav-wrap {
  flex: 1;
  justify-content: center;
  min-width: 0;
  margin: 0 clamp(0.5rem, 1.5vw, 1.5rem);
  transform: translateX(-0.75rem);
  // background: red;
}

.nav-menu {
  height: 4.375rem;
  gap: clamp(0.75rem, 2.5vw, 3.25rem);
  min-width: 0;
  margin: 0;
}

.header-phone {
  flex-shrink: 0;
  color: #2f374a;
  text-decoration: none;
  white-space: nowrap;
  line-height: 1;
  transition: color 0.2s;

  &:hover {
    color: #009d42;
  }
}

.nav-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 6.5rem;
  max-width: 7rem;
  height: 4.375rem;
  padding: 0 0.5rem;
  color: #2f374a;
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 1;
  border-bottom: 0.1875rem solid transparent;
  box-sizing: border-box;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: 0;
    height: 100%;
    background: linear-gradient(135deg, rgba(57, 181, 74, 0.08) 0%, rgba(57, 181, 74, 0.02) 100%);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(-50%);
    border-radius: 0.5rem 0.5rem 0 0;
  }

  &:hover {
    color: #39b54a;
    transform: translateY(-0.125rem);

    &::before {
      width: 90%;
    }
  }

  &.active {
    color: #39b54a;
    font-weight: 500;
    background-color: #e6f5ec;
    border-bottom-color: #39b54a;

    &::before {
      width: 100%;
      background: linear-gradient(135deg, rgba(57, 181, 74, 0.12) 0%, rgba(57, 181, 74, 0.04) 100%);
    }
  }
}

.search-icon-btn {
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #64748b;
  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: color 0.2s, background 0.2s, transform 0.2s;

  i {
    font-size: 1.375rem;
    line-height: 1;
  }

  &:hover {
    color: #009d42;
    background: rgba(0, 157, 66, 0.08);
    transform: translateY(-0.0625rem);
  }
}

.login-btn,
.logout-btn {
  width: 6.25rem;
  height: 2.75rem;
  border-radius: 0.5rem;
  background: linear-gradient(135deg, #009D42 0%, #00b050 50%, #009D42 100%);
  background-size: 200% 200%;
  border: none;
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 0.125rem 0.5rem rgba(0, 157, 66, 0.25);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.2) 50%, transparent 100%);
    transition: left 0.5s ease;
  }

  &:hover {
    transform: translateY(-0.125rem);
    box-shadow: 0 0.25rem 1rem rgba(0, 157, 66, 0.4);
    background-position: 100% 0;

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 0.125rem 0.5rem rgba(0, 157, 66, 0.3);
  }
}

.publish-btn {
  height: 2.75rem;
  padding: 0 1.25rem;
  border-radius: 0.5rem;
  background: #009D42;
  border-color: #009D42;
}

.user-trigger {
  cursor: pointer;
  padding: 0.375rem 0.75rem;
  border-radius: 1.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(57, 181, 74, 0.1) 0%, rgba(57, 181, 74, 0.05) 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: 1.5rem;
  }

  &:hover {
    transform: translateY(-0.0625rem);
    box-shadow: 0 0.25rem 0.75rem rgba(57, 181, 74, 0.15);

    &::before {
      opacity: 1;
    }

    .user-avatar {
      transform: scale(1.1);
      box-shadow: 0 0 0 0.1875rem rgba(57, 181, 74, 0.2);
    }

    .user-name {
      color: #39b54a;
    }
  }
}

.user-avatar {
  cursor: pointer;
  border-radius: 50%;
  object-fit: cover;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.user-name {
  color: #2f374a;
  white-space: nowrap;
  cursor: pointer;
  max-width: 7.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 1200px) {
  .logo-text {
    display: none;
  }

  .nav-item {
    font-size: 0.875rem;
    max-width: 4.5rem;
  }
}

@media (max-width: 992px) {
  .user-name {
    display: none;
  }
}

.logout-modal {
  padding: 0;
}

.logout-header {
  padding: 1.5rem 1.5rem 1rem;
}

.logout-icon-wrap {
  width: 2.5rem;
  height: 2.5rem;
  margin-right: 0.75rem;
  flex-shrink: 0;
}

.logout-icon {
  width: 1.25rem;
  height: 1.25rem;
  display: block;
}

.logout-title {
  color: #111827;
}

.logout-message {
  padding: 1.25rem 1.5rem;
  color: #444653;
  background: #F6F6F6;
}

.logout-actions {
  gap: 0.75rem;
  padding: 1.25rem 1.5rem 1.5rem;
}

.logout-btn-cancel {
  min-width: 5.5rem;
  height: 2.5rem;
  padding: 0 1.25rem;
  color: #374151;
  background: #fff;
  border: 0.0625rem solid #e5e7eb;
  border-radius: 0.5rem;
  cursor: pointer;

  &:hover {
    border-color: #d1d5db;
  }
}

.logout-btn-confirm {
  min-width: 5.5rem;
  height: 2.5rem;
  padding: 0 1.25rem;
  color: #fff;
  background: #006C49;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;

  &:hover {
    background: #008a3a;
  }
}

.login-modal {
  padding: 0;
}

.login-logo-box {
  width: 4rem;
  height: 4rem;
  background: #00a854;
  border-radius: 0.75rem;
  flex-shrink: 0;
}

.login-logo-text {
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.03125rem;
}

.login-title {
  color: #333;
  font-weight: 500;
}

.login-form {
  ::v-deep .el-form-item {
    margin-bottom: 1.375rem;
  }

  ::v-deep .el-form-item__label {
    float: none;
    display: block;
    line-height: 1;
    padding: 0 0 0.625rem;
    text-align: left;
  }

  ::v-deep .el-form-item__content {
    line-height: 1;
  }

  ::v-deep .el-form-item__error {
    padding-top: 0.25rem;
  }
}

.login-label {
  color: #333;
  font-weight: 400;
}

.login-label-icon {
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.375rem;
  flex-shrink: 0;
  object-fit: contain;
}

.login-input {
  ::v-deep .el-input__inner {
    height: 3.5rem;
    line-height: 3.5rem;
    border: 0.0625rem solid #ebeef5;
    border-radius: 0.625rem;
    font-size: 0.875rem;
    color: #333;
    background: #f5f7fa;
    padding: 0 1rem;
    box-shadow: none;

    &::placeholder {
      color: #c0c4cc;
    }

    &:hover {
      border-color: #dcdfe6;
      background: #f5f7fa;
    }

    &:focus {
      border-color: #00a854;
      background: #fff;
    }
  }
}

.code-field {
  display: flex;
  align-items: stretch;
  height: 3.5rem;
  background: #fff;
  border: 0.0625rem solid #dcdfe6;
  border-radius: 0.625rem;
  box-sizing: border-box;
  transition: border-color 0.2s;

  &:focus-within {
    border-color: #c0c4cc;
  }
}

.code-field__input {
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 0 1rem;
  color: #333;
  background: #fff;
  border: none;
  outline: none;
  border-radius: 0.5625rem 0 0 0.5625rem;
  box-sizing: border-box;

  &::placeholder {
    color: #c0c4cc;
  }
}

.code-field__action {
  flex: 0 0 5.5rem;
  width: 5.5rem;
  margin: -0.0625rem -0.0625rem -0.0625rem 0;
  border: 0.0625rem solid #00a854;
  border-radius: 0 0.5625rem 0.5625rem 0;
  box-sizing: border-box;
  overflow: hidden;

  &.is-disabled {
    border-color: #dcdfe6;
  }
}

.code-field__btn {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  color: #00a854;
  background: #fff;
  border: none;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  box-sizing: border-box;
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: #f0faf4;
  }

  &:disabled {
    color: #c0c4cc;
    cursor: not-allowed;
    background: #fff;
  }
}

.login-submit-btn {
  display: block;
  width: 100%;
  height: 3.5rem;
  margin-top: 2.5rem;
  color: #fff;
  font-weight: 500;
  background: #00a854;
  border: none;
  border-radius: 1.5rem;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #009d42;
  }
}

.login-agreement {
  ::v-deep .el-checkbox {
    display: flex;
    align-items: flex-start;
    white-space: normal;
  }

  ::v-deep .el-checkbox__input {
    margin-top: 0.125rem;
  }

  ::v-deep .el-checkbox__label {
    padding-left: 0.5rem;
    white-space: normal;
    line-height: 1.6;
  }

  ::v-deep .el-checkbox__inner {
    width: 1rem;
    height: 1rem;
    border-radius: 0.1875rem;
  }

  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #00a854;
    border-color: #00a854;
  }

  ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #909399;
  }

  ::v-deep .el-checkbox__inner:hover {
    border-color: #00a854;
  }
}

.agreement-text {
  color: #909399;
}

.agreement-link {
  color: #00a854;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>

<style lang="scss">
.v-modal {
  background-color: rgba(0, 0, 0, 0.75) !important;
  opacity: 1 !important;
}

.logout-dialog {
  border-radius: 0.75rem;
  overflow: hidden;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }
}

.login-dialog {
  border-radius: 1.25rem;
  overflow: hidden;
  box-shadow: 0 0.75rem 3rem rgba(0, 0, 0, 0.12);

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 2.5rem 1.875rem 2.25rem;
  }
}
</style>
